var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background", on: { click: _vm.closeFilters } },
    [
      _c("smart-back-button", { attrs: { backToLabel: _vm.backToLbl } }),
      _c(
        "v-row",
        { staticClass: "px-16 mb-12 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v(_vm._s(_vm.pageHeader)),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "5" } },
                    [
                      _c("smart-text-field", {
                        staticClass: "employees-search-bar",
                        attrs: {
                          placeholder: "Search",
                          search: true,
                          clearable: true,
                          "css-class": { "mt-2": _vm.mdAndUp },
                          "background-color": "white",
                        },
                        on: {
                          clear: _vm.onClear,
                          input: function ($event) {
                            return _vm.applyFilters()
                          },
                          "enter-pressed": function ($event) {
                            return _vm.applyFilters()
                          },
                        },
                        model: {
                          value: _vm.term,
                          callback: function ($$v) {
                            _vm.term = $$v
                          },
                          expression: "term",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-spacer", { class: { "mr-4": _vm.smAndDown } }),
                  _c(
                    "v-col",
                    {
                      class: {
                        "pl-0 pt-4": _vm.smAndDown,
                        "pt-5": _vm.mdAndUp,
                      },
                      attrs: { cols: "auto" },
                    },
                    [
                      _c("smart-btn", {
                        staticClass: "fr mt-n2",
                        class: { "w-100-pct": _vm.smAndDown },
                        attrs: {
                          label: "Add Employee",
                          icon: _vm.ic_plus,
                          "icon-class": "mr-3",
                          "icon-width": "12",
                          "icon-position": "left",
                          type: "primary",
                        },
                        on: { click: _vm.openNewUserPopup },
                      }),
                      _c("smart-btn", {
                        staticClass: "fr",
                        class: {
                          "w-100-pct mt-4": _vm.smAndDown,
                          "mr-4 export-csv mt-n2": _vm.mdAndUp,
                        },
                        attrs: {
                          icon: _vm.ic_download,
                          label: "Export CSV",
                          "icon-class": "mr-2",
                          "icon-position": "left",
                          "icon-width": "18",
                          bg: "white",
                          border: "navy-blue",
                          font: "navy-blue",
                        },
                        on: { click: _vm.csvExport },
                      }),
                      _c(
                        "v-btn-toggle",
                        {
                          staticClass: "fr",
                          class: {
                            "w-100-pct mt-4": _vm.smAndDown,
                            "mr-4 mt-n2": _vm.mdAndUp,
                          },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "base bg-white filters-btn client-users-filters-btn left px-4",
                              class: { "w-100-pct": _vm.smAndDown },
                              attrs: { outlined: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.showHideFilters.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "mr-2",
                                attrs: { width: "12", src: _vm.ic_filters },
                              }),
                              _vm._v(" Filters "),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("client-user-filters", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showFilters,
                            expression: "showFilters",
                          },
                        ],
                        on: {
                          close: function ($event) {
                            _vm.showFilters = false
                          },
                          applyFilters: _vm.applyFilters,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-row", { staticClass: "mt-8" }, [
                _c("label", { staticClass: "afs-clients" }, [
                  _vm._v(_vm._s(_vm.filteredUsers.length)),
                ]),
                _c("label", { staticClass: "ml-1 account-lbl" }, [
                  _vm._v("employees"),
                ]),
              ]),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "users-grid-wrapper pl-3 br-10" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _c("afs-client-users-grid", {
                                on: {
                                  statusChanged: _vm.statusChanged,
                                  editUser: _vm.editUser,
                                  manageAccess: _vm.manageAccess,
                                  viewActivity: _vm.viewActivity,
                                  manageTiles: _vm.manageTiles,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.pagingLength > 1
                ? _c(
                    "v-row",
                    { staticClass: "mt-6", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c("v-pagination", {
                            staticClass: "pl-3",
                            attrs: {
                              length: _vm.pagingLength,
                              "total-visible": "10",
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-snackbar",
                {
                  staticClass: "smart-snackbar",
                  scopedSlots: _vm._u([
                    {
                      key: "action",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._b(
                              {
                                attrs: { color: "#007BFF", text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.snackbar = false
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            [_vm._v(" Close ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.snackbar,
                    callback: function ($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar",
                  },
                },
                [
                  _c("img", {
                    staticClass: "success-icon",
                    attrs: { src: _vm.ic_green_success_checkmark },
                  }),
                  _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading Employees"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", scrollable: "", eager: "" },
          model: {
            value: _vm.displayEditUserPopup,
            callback: function ($$v) {
              _vm.displayEditUserPopup = $$v
            },
            expression: "displayEditUserPopup",
          },
        },
        [
          _c("add-edit-client-user", {
            on: {
              close: function ($event) {
                _vm.displayEditUserPopup = false
              },
              userSaved: _vm.userSaved,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "900px",
            "min-height": "80%",
            scrollable: "",
            eager: "",
          },
          model: {
            value: _vm.showAccessControl,
            callback: function ($$v) {
              _vm.showAccessControl = $$v
            },
            expression: "showAccessControl",
          },
        },
        [
          _c("user-access-control", {
            attrs: {
              allUsers: _vm.allUsersComputed,
              accessControl: _vm.accessControlComputed,
              currentUser: _vm.currentUserComputed,
            },
            on: {
              close: function ($event) {
                _vm.showAccessControl = false
              },
              accessSaved: _vm.accessSaved,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", scrollable: "", eager: "" },
          on: { close: _vm.onAddUserPopupClose },
          model: {
            value: _vm.displayAddUserPopup,
            callback: function ($$v) {
              _vm.displayAddUserPopup = $$v
            },
            expression: "displayAddUserPopup",
          },
        },
        [
          _c("add-edit-client-user", {
            attrs: { new: true },
            on: {
              close: function ($event) {
                _vm.displayAddUserPopup = false
              },
              userSaved: _vm.userSaved,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }